import { callApi, configureApiClient } from "../api/client";
import { PublicTeamsService } from "../generated/api/services/PublicTeamsService";

type DomainResolveResponse = {
  teamCode?: string | null;
};

export const resolveTeamCodeByDomain = async (
  domain: string
): Promise<string | null> => {
  try {
    configureApiClient();
    const response = await callApi<DomainResolveResponse>(
      () => PublicTeamsService.getApiPublicTeamsResolve(domain),
      "無法取得團隊代碼"
    );

    if (typeof response?.teamCode === "string" && response.teamCode.trim()) {
      return response.teamCode.trim();
    }

    return null;
  } catch (error) {
    console.error("Failed to resolve team code by domain", error);
    return null;
  }
};
